export default "__VITE_ASSET__CF834FiP__"